export function getEvents({ commit }) {
  return this.$fs
    .collection('events')
    .orderBy('dateStart')
    .get()
    .then((fsData) => {
      const list = [];
      fsData.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
      this.$logger('info', [`[action] getEvents`, list]);
      commit('updateEventsState', {
        state: 'events',
        data: list
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] getEvents', err]);
    });
}

export function createEvent({ dispatch }, payload) {
  let id;
  return this.$fs
    .collection('events')
    .add(payload)
    .then(async (data) => {
      id = data.id;
      this.$logger('info', [`[action] createEvent`, payload]);
      await dispatch('getEvents');
      dispatch('core/popToast', 'positive', {
        root: true
      });
      return id;
    })
    .catch((err) => {
      this.$logger('error', ['[action] createEvent', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function updateEvent({ dispatch }, payload) {
  return this.$fs
    .collection('events')
    .doc(payload.id)
    .update(payload)
    .then(async () => {
      this.$logger('info', [`[action] updateEvent`, payload]);
      await dispatch('getEvents');
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] updateEvent', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function respondToEvent({ dispatch }, payload) {
  const responses = ['attending', 'maybe', 'declined'];
  return this.$fs
    .collection('events')
    .doc(payload.event)
    .update({
      [`participants.${payload.response}`]: this.$fs2.FieldValue.arrayUnion(
        payload.user
      )
    })
    .then(async () => {
      const otherResponses = responses.filter((x) => x !== payload.response);
      for (const response of otherResponses) {
        await this.$fs
          .collection('events')
          .doc(payload.event)
          .update({
            [`participants.${response}`]: this.$fs2.FieldValue.arrayRemove(
              payload.user
            )
          });
      }
    })
    .then(async () => {
      this.$logger('info', [`[action] respondToEvent`, payload]);
      await dispatch('getEvents');
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] respondToEvent', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function updateGuests({ dispatch }, payload) {
  return this.$fs
    .collection('events')
    .doc(payload.id)
    .update({
      [`participants.guests.${payload.user}`]: payload.guests
    })

    .then(async () => {
      this.$logger('info', [`[action] updateGuests`, payload]);
      await dispatch('getEvents');
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] updateGuests', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

// Categories
export function getEventCategories({ commit }) {
  return this.$fs
    .collection('eventCategories')
    .orderBy('createdAt')
    .get()
    .then((fsData) => {
      const list = [];
      fsData.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
      this.$logger('info', [`[action] getEventCategories`, list]);
      commit('updateEventsState', {
        state: 'categories',
        data: list
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] getEventCategories', err]);
    });
}

export function createEventCategory({ dispatch }, payload) {
  return this.$fs
    .collection('eventCategories')
    .add(payload)
    .then(async () => {
      this.$logger('info', [`[action] createEventCategory`, payload]);
      await dispatch('getEventCategories');
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] createEventCategory', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function updateEventCategory({ dispatch }, payload) {
  return this.$fs
    .collection('eventCategories')
    .doc(payload.id)
    .update(payload)
    .then(async () => {
      this.$logger('info', [`[action] updateEventCategory`, payload]);
      await dispatch('getEventCategories');
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] updateEventCategory', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function deleteEventCategory({ dispatch }, id) {
  return this.$fs
    .collection('eventCategories')
    .doc(id)
    .delete()
    .then(async () => {
      this.$logger('info', [`[action] deleteEventCategory`, id]);
      await dispatch('getEventCategories');
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] deleteEventCategory', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

// Event Comments
export function getEventComments({ commit }, payload) {
  return this.$fs
    .collection('eventComments')
    .where('eventId', '==', payload)
    .orderBy('createdAt', 'desc')
    .get()
    .then((fsData) => {
      const list = [];
      fsData.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
      this.$logger('info', [`[action] getEventComments`, list]);
      commit('updateEventsState', {
        state: 'eventComments',
        data: list
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] getEventComments', err]);
    });
}

export function getAllEventComments({ commit }) {
  return this.$fs
    .collection('eventComments')
    .orderBy('createdAt', 'desc')
    .get()
    .then((fsData) => {
      const list = [];
      fsData.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
      this.$logger('info', [`[action] getAllEventComments`, list]);
      commit('updateEventsState', {
        state: 'eventComments',
        data: list
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] getComments', err]);
    });
}

export function createEventComment({ dispatch }, payload) {
  return this.$fs
    .collection('eventComments')
    .add(payload)
    .then(async () => {
      this.$logger('info', [`[action] createEventComment`, payload]);
      await dispatch('getEventComments', payload.eventId);
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] createEventComment', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function updateEventComment({ dispatch }, payload) {
  return this.$fs
    .collection('eventComments')
    .doc(payload.data.id)
    .update(payload.data)
    .then(async () => {
      this.$logger('info', [`[action] updateEventComment`, payload]);
      await dispatch('getEventComments', payload.event);
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] updateEventComment', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function deleteEventComment({ dispatch }, payload) {
  return this.$fs
    .collection('eventComments')
    .doc(payload.id)
    .update({
      deleted: true,
      deletedAt: this.$fs2.FieldValue.serverTimestamp()
    })
    .then(async () => {
      this.$logger('info', [`[action] deleteEventComment`, payload]);
      await dispatch('getEventComments', payload.event);
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] deleteEventComment', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function reportEventComment(
  { dispatch },
  { comment, reportedBy, reportedAt, event }
) {
  return this.$fs
    .collection('eventComments')
    .doc(comment.id)
    .update({
      requiresModeration: true,
      ['moderation.reports']: this.$fs2.FieldValue.arrayUnion({
        reportedAt,
        reportedBy
      })
    })
    .then(async () => {
      this.$logger('info', [`[action] reportEventComment`, comment]);
      await dispatch('getEventComments', event);
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] reportEventComment', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function getReportedEventComments({ commit }, payload) {
  return this.$fs
    .collection('eventComments')
    .where('requiresModeration', '==', true)
    .orderBy('createdAt', 'desc')
    .get()
    .then((fsData) => {
      const list = [];
      fsData.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
      this.$logger('info', [`[action] getReportedEventComments`, list]);
      commit('updateEventsState', {
        state: 'reportedComments',
        data: list
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] getReportedEventComments', err]);
    });
}

export function deleteEvent({ dispatch }, payload) {
  return this.$fs
    .collection('events')
    .doc(payload)
    .delete()
    .then(async () => {
      await dispatch('getEvents');
      dispatch('core/popToast', 'positive', {
        root: true
      });
    })
    .catch((err) => {
      this.$logger('error', ['[action] deleteEvent', err]);
      dispatch('core/popToast', 'negative', {
        root: true
      });
    });
}

export function startEventListener({ commit }) {
  return this.$fs
    .collection('events')
    .orderBy('dateStart')
    .onSnapshot(
      (fsData) => {
        const list = [];
        fsData.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
        this.$logger('info', [`[action] startEventListener`, list]);
        commit('updateEventsState', {
          state: 'events',
          data: list
        });
      },
      (err) => {
        this.$logger('error', ['[action] startEventListener', err]);
      }
    );
}

export function startCommentListener({ commit }, payload) {
  return this.$fs
    .collection('eventComments')
    .where('eventId', '==', payload)
    .orderBy('createdAt', 'desc')
    .onSnapshot(
      (fsData) => {
        const list = [];
        fsData.forEach((doc) => list.push({ id: doc.id, ...doc.data() }));
        this.$logger('info', [`[action] startCommentListener`, list]);
        commit('updateEventsState', {
          state: 'comments',
          data: list
        });
      },
      (err) => {
        this.$logger('error', ['[action] startCommentListener', err]);
      }
    );
}
